<template>
  <div class="footer">
    <b-container>
      <b-row>
        <!-- Блок с Лого -->
        <b-col>
          <b-link to="/">
            <img alt="RIS"
                 src="../assets/logo_ru.png"
                 width="64" />
          </b-link>

          <b-link href="https://rris.ru/sochi-001/about"
                  target="_blank"
                  class="ml-5">О компании</b-link>
        </b-col>

        <!-- Социальные кнопки -->
        <b-col class="social text-right">
          <ul class="list">
            <!-- Facebook -->
            <li>
              <a href="https://www.facebook.com/restris/"
                 target="_blank"
              >
                <i class="soc-ic soc-ic-fb"></i>
              </a>
            </li>

            <!-- VK -->
            <li>
              <a href="https://vk.com/restrris"
                 target="_blank"
              >
                <i class="soc-ic soc-ic-vk"></i>
              </a>
            </li>

            <!-- Instagram -->
            <li>
              <a href="https://www.instagram.com/restrris/"
                 target="_blank"
              >
                <i class="soc-ic soc-ic-instagram"></i>
              </a>
            </li>

            <!-- Youtube -->
            <li>
              <a href="https://www.youtube.com/channel/UCoprI78rmvlTAXuGPzQt_2Q"
                 target="_blank"
              >
                <i class="soc-ic soc-ic-youtube"></i>
              </a>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>

    <b-container>
      <b-row class="mt-5">
        <b-col class="text-light">
          <b-link v-b-modal.modal-privacy
                  class="ml-1"
          >
            Политика конфиденциальности
          </b-link>
        </b-col>
        <b-col class="text-dark text-right">
          <p>© Сеть ресторанов Рис. 2020</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
  };
</script>

<style scoped lang="scss">
  .footer {
    margin-top: 30px;
    margin-bottom: 10px;

    .social {
      .text {
        display: inline-block;
        font-size: 14px;
        vertical-align: middle;
      }
      .list {
        display: inline-block;
        margin: 0 12px !important;
        padding: 0;
        vertical-align: middle;

        & > li {
          display: inline-block;
          margin-right: -1px;
          padding: 0 !important;
          vertical-align: middle;
        }

        .soc-ic {
          display: inline-block;
          margin: 0 10px 10px;
          width: 30px;
          height: 30px;
          vertical-align: middle;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: contain;
        }

        .soc-ic-instagram {
          background-image: url("/instagram.svg");
        }

        .soc-ic-fb {
          background-image: url("/facebook.svg");
        }

        .soc-ic-vk {
          background-image: url("/vk.svg");
        }

        .soc-ic-youtube {
          background-image: url("/youtube.svg");
        }
      }
    }
  }
</style>
